import { useNavigate } from "react-router-dom";
import "./SideBar.css";
import SideBarButton from "./SideBarButton";
import DarkModeToggle from "./DarkModeToggle";

function SideBar({loggedIn, loginFunc, isOpen, onToggle}) {
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
    };

    return (
        <div>
            {isOpen && <div className="side-bar-overlay" onClick={() => onToggle?.(false)}></div>}
            <div className="side-bar" data-open={isOpen}>
            <div className="padding"></div>
            <SideBarButton text="Saved Ideas & Palettes" onClick={() => {
                if(loggedIn) handleNavigation("/saved");
                else loginFunc();
            }}></SideBarButton>
            <SideBarButton text="Idea & Palette generator" onClick={() => {
                handleNavigation("/generate/palette-idea")
            }}></SideBarButton>
            <SideBarButton text="Palette only generator" onClick={() => {
                handleNavigation("/generate/palette")
            }}></SideBarButton>
            <SideBarButton text="Idea only generator" onClick={() => {
                handleNavigation("/generate/idea")
            }}></SideBarButton>
                <div className="side-bar-footer">
                    <DarkModeToggle />
                    <button onClick={() => {
                        if(loggedIn) handleNavigation("/account-settings");
                        else loginFunc();
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="w-5 h-5" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        Account Settings
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SideBar;